import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  z-index: ${({ theme }) => theme.zIndex[2]};
  margin-bottom: ${rem(24)};
  padding-right: ${rem(44)};
  text-align: left;

  .address-auto-complete {
    height: 38px;

    & div[class*='control'] {
      border-color: ${({ theme }) => theme.colors.palette.grey};
    }

    & div[class*='control']:focus,
    & div[class*='control']:focus-visible,
    & div[class*='control']:hover {
      --focus-color: ${({ theme }) => theme.colors.palette.teal};

      background-color: ${({ theme }) => rgba(theme.colors.palette.teal, 0.05)};
      border-color: ${({ theme }) => theme.colors.palette.teal};
      box-shadow:
        inset 0 0 0 2px #fff,
        0 0 0 2px var(--focus-color),
        0 0 8px var(--focus-color);
    }

    & div[class*='option']:hover {
      background-color: ${({ theme }) => rgba(theme.colors.palette.teal, 0.05)};
    }

    & input:focus-visible {
      border: none;
      box-shadow: none;
    }
  }
`;

interface LinkProps {
  isDisabled: boolean;
}

export const AutoCompleteLink = styled.a<LinkProps>`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 38px;
  height: 38px;
  outline: none;
  cursor: pointer;
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};

  svg.directions {
    width: 100%;
    height: 100%;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: ${rem(4)};
`;
